/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { forEach, get, isArray, isFunction, isUndefined } from "lodash";
import DeleteIcon from "../../../assets/images/icon/delete-icon.svg";
// component
import BillForm from "../../../components/BillForm";
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import Radios from "../../../components/Radio/Radios";
import DataComponent from "../../../components/DataComponent";
import IconButton from "../../../components/Button/IconButton";
import SupplyCostCalculator from "../../../components/BillForm/SupplyCostCalculator";
import SelectClientInfo from "../../../components/BillForm/SelectClientInfo";
import DatePicker from "../../../components/DatePicker";
import SelectItemList from "../../../components/BillForm/SelectItem";
// hooks
import useForm from "../../../hooks/useForm";
// utils
import {
  dateToFormat,
  getDay,
} from "../../../utils/date";
import { classnames } from "../../../utils/text";
import systemAlert from "../../../utils/systemAlert";
import { toast } from "../../../utils/toast";
// apis
import { getCompaniesDetail } from "../../../apis/companies/company-infos";
import { judgeRegNumTyp } from "../../../utils/tax-invoice-type";
import { viewLoading } from "../../../utils/loading";
import {
  createTaxInvoicesIssue,
  deleteInvoiceMappingTaxInvoice,
  deleteToEtcInvoice,
  directEditTaxInvoice,
  directTaxInvoice,
  getInvoiceItemsExcelSample,
  getTaxInvoice
} from "../../../apis/invoices";
import { restoreComma, transformComma } from "../../../utils/validator/comma";
import { postFilesExcel } from "../../../apis/files";
import { excelUploadData } from "../../../utils/excelUploadData";
import { download } from "../../../utils/download";
import { cleanObj } from "../../../utils/cleanObj";
import { ControlTable } from "../../../components/Table";
import { autoHyphen } from "../../../utils/replace";
import EtcInvoiceMapping from "../Trade/EtcInvoiceMapping";
import { accountName } from "../../../utils/account-name";
import { deleteBanksTransItems } from "../../../apis/finances/bank";
import { isEmpty } from "../../../utils/lodashExtend";
import { getAccountsList } from "../../../apis/companies/account";
import Client from "../../Client/Client";


const TAX_TYPE_LIST = [
  { label: "과세", value: "tax" },
  { label: "면세", value: "tax_free" },
  { label: "영세", value: "small_biz" },
];

// invoicer 공급자
// invoicee 공급받는자
const TaxInvoiceCreate = ({
  open,
  setOpen,
  supByrType = "sales",
  submit,
  data,
  list = [],
  setList = () => { },
  direct = "",
  mode = "create",
  permission = {},
}) => {

  const { user, permissions } = useSelector((store) => ({
    user: store.Profile.user,
    permissions: store.Profile.permissions,
  }));
  const [companyInfo, setCompanyInfo] = useState({});
  const [fields, setFields] = useState([]);
  // 품목 리스트

  // 품목 값
  const [initItemValues] = useState([
    {
      trMonth: `${new Date().getMonth() + 1}`,
      trDate: String(new Date().getDate()),
      prodName: "",
      unit: "",
      qty: "",
      unitCost: "",
      supplyCost: "",
      taxAmt: "",
      remark: "",
    },
  ]);
  const [itemValues, setItemValues] = useState([
    {
      trMonth: `${new Date().getMonth() + 1}`,
      trDate: String(new Date().getDate()),
      prodName: "",
      unit: "",
      qty: "",
      unitCost: "",
      supplyCost: "",
      taxAmt: "",
      remark: "",
    },
  ]);
  // 계산 state
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [calculatorValue, setCalculatorValue] = useState({});
  const [calculItemIdx, setCalculItemIdx] = useState(0);
  // 거래처 불러오기
  const [clientSearchOpen, setClientSearchOpen] = useState(false);
  // 거래처 등록 모달 오픈
  const [accountOpen, setAccountOpen] = useState(false);
  const [accountDefaultAddForm, setAccountDefaultAddForm] = useState({});
  // 품목 불러오기
  const [itemSearchOpen, setItemSearchOpen] = useState(false);
  const [itemIdx, setItemIdx] = useState(0);

  // 연관된 거래명세서
  const [mappedInvoiceFields, setMappedInvoiceFields] = useState([]);
  const [mappedInvoiceData, setMappedInvoiceData] = useState([]);

  // 매핑된 견적서 / 발주서
  const [mappedEtcInvoiceFields, setMappedEtcInvoiceFields] = useState([]);
  const [mappedEtcInvoiceData, setMappedEtcInvoiceData] = useState([]);

  // 매핑된 은행계좌 / 기타거래
  const [bankTransFields] = useState([
    {
      title: "거래일자",
      key: "tradeTime",
      onValue: (value) => {
        return dateToFormat(value, "YYYY.MM.DD");
      },
    },
    {
      title: "계좌정보",
      key: "bankName",
      onValue: (_value, _field, data) =>
        data.bankAccount?.type === "cash_account" ? "기타거래" :
          accountName(data.bankName, data.bankAccountNo)

    },
    { title: "입금액", key: "inAmt", type: "comma" },
    { title: "출금액", key: "outAmt", type: "comma" },
    {
      title: "거래자명", key: "traderName"
    },
    {
      title: "입금자명", key: "sendBankAccountHolder"
    },
    {
      title: "적요", key: "remark"
    },
    {
      title: "적요(상세)", key: "detail"
    },
    {
      title: "메모", key: "memo"
    },
  ]);
  const [cashTransMappingData, setCashTransMappingData] = useState(null);
  const [bankTransMappingData, setBankTransMappingData] = useState(null);

  // 발주서/견적서 매핑하기
  const [isEtcInvoiceMapping, setIsEtcInvoiceMapping] = useState(false);
  const [etcInvoiceMappingData, setEtcInvoiceMappingData] = useState(null);

  const [invoicePermission, setInvoicePermission] = useState({});
  const [accountPermission, setAccountPermision] = useState({});


  useEffect(() => {
    if (!isEmpty(permissions)) {
      setInvoicePermission(permissions.find(p => p.code === "TRADE_INVOICE"));
      setAccountPermision(permissions.find((p) => p.code === "COMPANY_ACCOUNT"));
    }
  }, [permissions]);

  useEffect(() => {
    if (itemValues.length > 16) {
      systemAlert('품목은 최대 16개 까지만 추가,삭제 가능합니다.');
    }
  }, [itemValues]);

  useEffect(() => {
    if (mode === "detail") {
      setMappedInvoiceFields([
        { title: "일자", key: "writeDate" },
        { title: "상호", key: supByrType === 'sales' ? "byrCorpName" : "supCorpName" },
        { title: "대표자명", key: supByrType === 'sales' ? "byrRepName" : "supRepName" },
        {
          title: "사업자번호",
          key: supByrType === 'sales' ? "byrBizNo" : "supBizNo",
          onValue: (value) => {
            return autoHyphen("comNum", value);
          },
        },
        {
          title: "대표품목",
          key: "items[0].prodName",
          onValue: (value, field, form) => {
            let items = "";
            if (!isEmpty(form.invoiceItems)) {
              forEach(form.invoiceItems, (item) => {
                if (item.order === 1) {
                  items =
                    form.invoiceItems.length > 1
                      ? `${item.prodName} 외 ${form.invoiceItems.length - 1}건`
                      : item.prodName;
                }
              });
            }

            return items;
          },
        },
        {
          title: "공급가액",
          key: "supplyAmt",
          onValue: (value) => {
            return transformComma(value);
          },
        },
        {
          title: "세액",
          key: "taxAmt",
          onValue: (value) => {
            return transformComma(value);
          },
        },
        {
          title: "합계금액",
          key: "totalAmt",
          onValue: (value) => {
            return transformComma(value);
          },
        },
        /*
        {
          title: "발행여부",
          key: "taxInvoiceIdx",
          onValue: (value, field, form) => {
            let issue = "";
            if (isNull(value) && !form.invoiceToTaxInvoice) {
              issue = "부";
            } else {
              // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
              issue = "세금계산서"
            }
  
            return issue;
          },
        },
        */
      ]);

      setMappedEtcInvoiceFields([
        { title: "구분", key: "etcInvoiceType", onValue: (value) => value === "quotation" ? "견적서" : "발주서" },
        { title: "작성일자", key: "writeDate", type: "date" },
        {
          title: "상호",
          onValue: (_value, _field, data) => {
            return data.supByrType === "sales" ? data["byrCorpName"] : data["supCorpName"];
          }
        },
        {
          title: "대표자명",
          onValue: (_value, _field, data) => {
            return data.supByrType === "sales" ? data["byrRepName"] : data["supRepName"];
          }
        },
        {
          title: "사업자번호",
          onValue: (_value, _field, data) => {
            const value = data.supByrType === "sales" ? data["byrBizNo"] : data["supBizNo"];
            return autoHyphen("comNum", value);
          }
        },
        { title: "대표품목", key: "itemName" },
        {
          title: "공급가액",
          key: "supplyAmt",
          type: "comma"
        },
        {
          title: "세액",
          key: "taxAmt",
          type: "comma"
        },
        {
          title: "합계금액",
          key: "totalAmt",
          type: "comma"
        },
      ]);
    }
  }, [mode]);


  const _submit = (form) => {
    if (itemValues.length > 16) {

      const item = itemValues[0];
      const itemLength = itemValues.length - 1;

      systemAlert(`품목은 최대 16개 까지 가능합니다.`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '대표품목변경',
            onClick: () => {
              setItemValues([{
                trMonth: item.trMonth,
                trDate: item.trDate,
                prodName: item.prodName + " (외 " + itemLength + "건)",
                unit: "",
                qty: "",
                unitCost: "",
                supplyCost: form.supplyAmt,
                taxAmt: form.taxAmt,
                remark: "",
              },]);
            }
          }
        ]
      });

      return;
    } else {
      if (isEmpty(form.clientIdx)) {
        getAccountsList({
          search: { name: `%${supByrType === "sales" ? form.byrCorpName : form.supCorpName}%` }
        })
          .then(res => {
            if (get(res, "data.count") > 0) {
              handleGetClient();
            } else {
              if (!isEmpty(accountPermission)) {
                systemAlert(`입력한 정보의 거래처가 없습니다. 거래처 등록 후 진행하시겠습니까?`, {
                  buttons: [
                    {
                      color: 'text',
                      label: '취소'
                    },
                    {
                      label: '등록하기',
                      onClick: () => {
                        setAccountOpen(true);
                        setAccountDefaultAddForm({
                          name: supByrType === "sales" ? form.byrCorpName : form.supCorpName,
                          ceoName: supByrType === "sales" ? form.byrRepName : form.supRepName,
                          comNum: supByrType === "sales" ? form.byrBizNo : form.supBizNo,
                        });
                      }
                    }
                  ]
                });
              } else {
                systemAlert("거래처 등록 권한이 없어 등록이 불가합니다.");
              }
            }
          });
      } else {
        for (const obj of itemValues) {
          if (isEmpty(obj.trMonth)) return toast.error("품목 거래 월을 입력해주세요");
          if (isEmpty(obj.trDate)) return toast.error("품목 거래 일을 입력해주세요");
          if (isEmpty(obj.prodName)) return toast.error("품목명을 입력해주세요");
          if (isEmpty(obj.supplyCost)) return toast.error("공급가액을 계산해주세요");
          if (isEmpty(obj.taxAmt) && form.taxType !== 'tax_free') return toast.error("공급가액을 계산해주세요");
        }

        const body = {
          invoiceIdx: !isEmpty(data) ? data.invoiceIdx : "",
          etxivClsfCd: !isEmpty(direct) ? "04" : form.taxType === 'tax_free' ? '03' : '01',
          etxivKndCd: form.taxType === 'small_biz' ? '02' : '01',
          etxivDmnrClsfCd: judgeRegNumTyp(form.byrBizNo),
          emailYn: !isEmpty(form.supEmail) || !isEmpty(form.byrEmail1) ? 'Y' : 'N', //optional
          splrChrgEmlAdr: form.supEmail, // optional
          wrtDt: dateToFormat(form.writeDate.toString(), 'YYYYMMDD'),
          rmrkCntn: form.memo,
          recApeClCd: form.recApeClCd,
          splrTxprDscmNo: form.supBizNo, // required
          splrMpbNo: form.supBizSubNo, // optional
          splrTnmNm: form.supCorpName, // required
          splrRprsFnm: form.supRepName, // required
          splrPfbAdr: form.supAddress, // optional
          splrBcNm: form.supBizCategory, // optional
          splrEmlAdr: form.supEmail, // optional
          splrItmNm: form.supBizItem, // optional
          dmnrTxprDscmNo: form.byrBizNo, // required
          dmnrMpbNo: form.byrBizSubNo, // optional
          dmnrTnmNm: form.byrCorpName, // required
          dmnrRprsFnm: form.byrRepName, // required
          dmnrPfbAdr: form.byrAddress, // optional
          dmnrBcNm: form.byrBizCategory, // optional
          dmnrItmNm: form.byrBizItem, // optional
          dmnrMchrgEmlAdr: form.byrEmail1, // optional
          dmnrMchrgEmlAdr2: form.byrEmail2 || "", // optional
          lsatInfrBizSVOList: itemValues.map((item) => ({
            lsatSplMm: String(item.trMonth),
            lsatSplDd: String(item.trDate),
            lsatNm: String(item.prodName),
            lsatRszeNm: String(item.unit),
            lsatQty: String(item.qty),
            lsatUtprc: restoreComma(item.unitCost),
            lsatSplCft: restoreComma(item.supplyCost),
            lsatTxamt: form.taxType === 'tax_free' ? "0" : restoreComma(item.taxAmt),
            lsatRmrkCntn: String(item.remark),
          })),
          ...(!isEmpty(direct) ? { invoiceType: direct } : {}),
          ...(!isEmpty(direct) ? { supByrType } : {}),
        };
        cleanObj(body);

        if (mode === "create") {
          systemAlert(`${direct === "paper_tax_invoice" ? "종이" : "전자"}(세금)계산서를 등록하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  viewLoading(true);
                  const apiCall = !isEmpty(body.invoiceType)
                    ? directTaxInvoice
                    : createTaxInvoicesIssue;
                  apiCall(body)
                    .then(() => {
                      if (isFunction(submit)) submit();
                      cancel();
                    })
                    .catch(() => { })
                    .finally(() => {
                      viewLoading(false);
                    });
                }
              }
            ]
          });
        } else {
          systemAlert(`${direct === "paper_tax_invoice" ? "종이" : "전자"}(세금)계산서를 수정하시겠습니까?`,
            {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '수정',
                  onClick: () => {
                    viewLoading(true);
                    directEditTaxInvoice(list.idx, body)
                      .then(() => {
                        if (isFunction(submit)) submit();
                        cancel();
                      })
                      .catch(() => { })
                      .finally(() => {
                        viewLoading(false);
                      });
                  }
                }
              ]
            }
          );
        }
      }
    }
  };

  const validate = ({
    supBizNo,
    supCorpName,
    supRepName,
    byrBizNo,
    byrCorpName,
    byrRepName,
  }) => {
    let error = {};
    if (!supBizNo) error.supBizNo = "등록번호는 필수입니다.";
    if (!supCorpName) error.supCorpName = "상호는 필수입니다.";
    if (!supRepName) error.supRepName = "성명은 필수입니다.";
    if (!byrBizNo) error.byrBizNo = "등록번호는 필수입니다.";
    if (!byrCorpName) error.byrCorpName = "상호는 필수입니다.";
    if (!byrRepName) error.byrRepName = "성명은 필수입니다.";
    return error;
  };

  const { form, setForm, errors, handleOnChange, handleSubmit, setErrors, reset } =
    useForm(
      {
        supByrType,
        issueType: 'tax_invoice',
        taxType: 'tax',
        supBizCategory: "",
        supBizItem: "",
        writeDate: getDay(),
        supBizNo: "",
        supBizSubNo: "",
        supCorpName: "",
        supRepName: "",
        supAddress: "",
        byrBizNo: "",
        byrBizSubNo: "",
        byrCorpName: "",
        byrRepName: "",
        byrAddress: "",
        byrBizCategory: "",
        byrBizItem: "",
        totalAmt: "",
        supplyAmt: "",
        taxAmt: "",
        remark: "",
        supEmail: "",
        byrEmail1: "",
        byrEmail2: "",
        memo: "",
        uploadFiles: "",
        items: "",
        recApeClCd: "02",
      },
      _submit,
      validate
    );


  const getTaxType = (taxKind, taxAmt) => {

    switch (taxKind) {
      case "영세율":
        return "small_biz";
      default:
        taxAmt === 0 ? "tax" : "tax_free";
    }
  };


  const setInvoice = (data) => {
    getTaxInvoice(data.idx).then((res) => {
      const taxInvoiceItems = [];
      forEach(res.data.taxInvoiceItems, item => {
        const date = item.itemDate.split('-');
        taxInvoiceItems.push({
          prodName: item.itemName,
          unit: item.itemStd,
          qty: item.itemQty + "",
          unitCost: item.itemUnitCost + "",
          supplyCost: item.itemSupAmt + "",
          taxAmt: item.itemTaxAmt + "",
          remark: '',
          trMonth: date[1] || "",
          trDate: date[2] || "",
        });
      });
      setItemValues(taxInvoiceItems);

      setTimeout(() => {
        setForm({
          ...res.data,
          memo: res.data?.remark || "",
          taxType: getTaxType(res.data?.taxKind || "", res.data?.taxAmt || 0)

        });
      }, 100);

      const cashTrans = (res.data?.registeredBankTrans || []).filter(item =>
        item.bankAccount?.type === "cash_account");

      const bankTrans = (res.data?.registeredBankTrans || []).filter(item =>
        item.bankAccount?.type !== "cash_account");

      setCashTransMappingData(cashTrans);
      setBankTransMappingData(bankTrans);

      setMappedEtcInvoiceData(res?.data?.mappedEtcInvoices || []);
      setMappedInvoiceData(res.data.mappedInvoices || []);
    });
  };

  useEffect(() => {
    if (open && !isEmpty(companyInfo) && !isEmpty(list)) {
      setInvoice(list);
    } else if (open && !isEmpty(companyInfo)) { // 전자(세금)계산서 -> 매출 -> 발급하기 실행 : 공급자 정보입력
      setForm({ ...(data || {}), ...getCompanyInfoByType() });
      setItemValues(data?.itemList || initItemValues);
    }

  }, [open, companyInfo, !isEmpty(list) && list, data]);

  useEffect(() => {
    if (user) {
      getCompaniesDetail(user.companyIdx).then((res) => {
        setCompanyInfo(res.data.company);
      });
    }
  }, [user]);

  useEffect(() => {
    let supplyAmt = 0;
    let taxAmt = 0;

    forEach(itemValues, (value) => {
      supplyAmt += Number(restoreComma(value.supplyCost));

      if (form.taxType !== 'tax_free') {
        taxAmt += Number(restoreComma(value.taxAmt));
      }
    });

    const totalAmt = supplyAmt + taxAmt;
    setForm({
      totalAmt: transformComma(totalAmt),
      taxAmt: transformComma(taxAmt),
      supplyAmt: transformComma(supplyAmt),
    });
  }, [itemValues, form.taxType]);

  const getCompanyInfoByType = () => {
    let info = {};
    switch (supByrType) {
      case "sales":
        info = {
          supByrType,
          supBizNo: companyInfo.comNum,
          supBizSubNo: companyInfo.sectNum,
          supCorpName: companyInfo.name,
          supRepName: companyInfo.ceoName,
          supAddress: isEmpty(companyInfo.address) ? "" : `${companyInfo.address} ${companyInfo.addressDetail}`,
          supBizCategory: companyInfo.bsnType,
          supBizItem: companyInfo.bsnSect,
          supEmail: companyInfo.taxEmail,
        };
        break;
      case "purchase":
        info = {
          supByrType,
          byrBizNo: companyInfo.comNum,
          byrBizSubNo: companyInfo.sectNum,
          byrCorpName: companyInfo.name,
          byrRepName: companyInfo.ceoName,
          byrAddress: isEmpty(companyInfo.address) ? "" : `${companyInfo.address} ${companyInfo.addressDetail}`,
          byrBizCategory: companyInfo.bsnType,
          byrBizItem: companyInfo.bsnSect,
          byrEmail1: companyInfo.taxEmail,
        };
        break;
      default:
        break;
    }
    return info;
  };


  const cancel = () => {
    setOpen(false);

    setItemValues(initItemValues);
    setErrors({});
    setList({});
    reset();
  };

  const handleGetClient = () => {
    setClientSearchOpen(true);
  };

  const uploadExcelFile = (e) => {
    const file = e.target.files[0];
    if (!isUndefined(file)) {
      const formData = new FormData();
      formData.append("file", file);
      postFilesExcel(formData)
        .then((res) => {
          const rows = get(res, "data.sheets[0].rows");
          const keys = [
            { idx: 1, key: "prodName", type: String },
            { idx: 2, key: "qty", type: String },
            { idx: 3, key: "unit", type: String },
            { idx: 4, key: "unitCost", type: Number },
            { idx: 5, key: "supplyCost", type: Number },
            { idx: 6, key: "taxAmt", type: Number },
            { idx: 7, key: "tradeDate", type: Date },
            { idx: 8, key: "remark", type: String },
          ];

          const excelData = {
            products: excelUploadData({ keys, rows }),
          };

          setItemValues(excelData.products.map((d) => ({
            trMonth: String(new Date(d.tradeDate).getMonth() + 1),
            trDate: String(new Date(d.tradeDate).getDay()),
            prodName: d.prodName,
            unit: d.unit,
            qty: d.qty,
            unitCost: transformComma(d.unitCost),
            supplyCost: transformComma(d.supplyCost),
            taxAmt: transformComma(d.taxAmt),
            remark: d.remark,
          })));
        });
    }
  };

  const [itemFields, setItemFields] = useState([]);

  useEffect(() => {
    setFields([
      [
        {
          title: "작성일자",
          key: "writeDate",
          type: "datepicker",
          className: "write-date",
          labelClassName: "font-size-13",
        },
        {
          title: "비고",
          key: "memo",
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: "비고 입력",
          },
        },
      ],
      [
        {
          title: "합계금액",
          key: "totalAmt",
          type: "input",
          className: "font-size-13",
          textAlign: "right",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },
        {
          title: "공급가액",
          key: "supplyAmt",
          className: "font-size-13",
          type: "input",
          textAlign: "right",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },
        ...(form.taxType !== 'tax_free' ? [{
          title: "세액",
          key: "taxAmt",
          className: "font-size-13",
          textAlign: "right",
          type: "input",
          options: {
            placeholder: "0",
            disabled: true,
          },
        },] : [])
      ],
    ]);

    setItemFields([
      {
        title: "월",
        key: "trMonth",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "월",
        },
        required: true,
      },
      {
        title: "일",
        key: "trDate",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "일",
        },
        required: true,
      },
      {
        title: "품목",
        key: "prodName",
        type: "input",
        className: "prod-name",
        options: {
          placeholder: "품목입력",
        },
        required: true,
      },
      {
        title: "단위",
        key: "unit",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "단위",
        },
      },
      {
        title: "수량",
        key: "qty",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "수량",
        },
      },
      {
        title: "단가",
        key: "unitCost",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "단가",
        },
      },
      {
        title: "합계",
        key: "sumCostCalc",
      },
      {
        title: "공급가액",
        key: "supplyCost",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "공급가액",
        },
        required: true,
      },
      ...(form.taxType !== 'tax_free' ? [
        {
          title: "세액",
          key: "taxAmt",
          type: "input",
          textAlign: "center",
          options: {
            placeholder: "세액",
          },
          required: true,
        },] : []),
      {
        title: "비고",
        key: "remark",
        type: "input",
        textAlign: "center",
        options: {
          placeholder: "비고",
        },
      },
    ]);
  }, [form]);

  const itemHeaderButtons = [
    {
      label: (
        <>
          샘플다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      size: "sm",
      action: () => {
        getInvoiceItemsExcelSample().then((res) => {
          download(res.data.url);
        });
      },
    },
    {
      label: "엑셀업로드",
      type: "excelFile",
      size: "sm",
      onChange: (e) => uploadExcelFile(e),
    },
    {
      label: "품목 추가",
      color: "line",
      size: "sm",
      action: () => {
        // 품목 값 추가
        setItemValues((oldVal) => [
          ...oldVal,
          {
            trMonth: dateToFormat(form.writeDate.toString(), "M"),
            trDate: String(new Date().getDate()),
            prodName: "",
            unit: "",
            qty: "",
            unitCost: "",
            supplyCost: "",
            taxAmt: "",
            remark: "",
          },
        ]);
      },
    },
  ];

  // 품목 change
  const handleOnChangeItemList = (e, idx) => {
    const { name, value } = e.target;
    const originValues = [...itemValues];
    let changedItemValues = originValues[idx];
    if (name === "unitCost" || name === "supplyCost" || name === "taxAmt") {
      changedItemValues = {
        ...changedItemValues,
        [name]: transformComma(value),
      };
    } else {
      changedItemValues = {
        ...changedItemValues,
        [name]: value,
      };
    }

    if (['unitCost', 'qty'].includes(e.target.name)) {
      if (!isEmpty(changedItemValues.qty) && !isEmpty(changedItemValues.unitCost)) {
        // 기본으로 부가세 미포함 금액 적용.
        const qty = Number(changedItemValues.qty);
        const unitCost = Number(restoreComma(changedItemValues.unitCost));
        const supplyCost = qty * unitCost;
        const taxAmt = Math.ceil(supplyCost * 0.1);

        changedItemValues = {
          ...changedItemValues,
          supplyCost: transformComma(supplyCost),
          taxAmt: transformComma(taxAmt)
        };
      }
    }

    originValues[idx] = changedItemValues;
    setItemValues(originValues);
  };

  // 품목 삭제
  const handleOnRemoveItem = (idx) => {
    // 품목 값 삭제
    setItemValues(() => [
      ...itemValues.filter((values, valueIndex) => valueIndex !== idx),
    ]);
  };


  const mappedInvoiceRowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        // 거래처 매핑
        type: "delete",
        action: (data) => {
          systemAlert('연관 거래명세서를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteInvoiceMappingTaxInvoice({ idxes: [data.invoiceToTaxInvoice.idx] })
                    .then(() => {
                      setInvoice(list);
                    })
                    .catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const mappedEtcInvoiceRowBtnConfig = {
    title: "삭제",
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert(`연관 견적서/발주서를 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "확인",
                onClick: () => {
                  deleteToEtcInvoice("taxInvoice", { idx: [data.etcInvoiceToTaxInvoice?.idx] })
                    .then(() => {
                      setInvoice(list);
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ]
  };

  const mappedBankTransRowBtnConfig = {
    title: "삭제",
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert(`연관 거래내역을 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "확인",
                onClick: () => {
                  deleteBanksTransItems(data?.bankTransItem?.idx)
                    .then(() => {
                      setInvoice(list);
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ]
  };


  const addAccountSubmit = (data) => {
    const account = data.account;
    const {
      idx,
      name,
      comNum,
      ceoName,
      address = "",
      addressDetail = "",
      industryType = "",
      industrySect = "",
      sectNum = "",
      email = "",
      taxEmail1 = "",
      taxEmail2 = "",
    } = account;


    if (supByrType === "sales") {
      setForm({
        ...form,
        clientIdx: idx,
        byrBizNo: comNum,
        byrBizSubNo: sectNum,
        byrCorpName: name,
        byrRepName: ceoName,
        byrAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        byrBizCategory: industryType,
        byrBizItem: industrySect,
        byrEmail1: taxEmail1 || email,
        byrEmail2: taxEmail2,
      });
    } else {
      setForm({
        ...form,
        clientIdx: idx,
        supBizNo: comNum,
        supBizSubNo: sectNum,
        supCorpName: name,
        supRepName: ceoName,
        supAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        supBizCategory: industryType,
        supBizItem: industrySect,
        supEmail: taxEmail1 || taxEmail2 || email,
      });
    }
    setAccountDefaultAddForm({});
  };



  return (
    <>
      <Modal isOpen={open} close={cancel} size="x-lg" className="p-0">
        <div className="trade-invoice-write">
          <ModalHeader>
            {`${direct === "paper_tax_invoice" ? "종이" : "전자"}(세금)계산서 ${mode === "create" ? "발급" : "수정"}`}
          </ModalHeader>
          {mode === "detail" && (
            <>
              <div className="header-button-wrap">
                <Button
                  className="print-button print-out"
                  color="gray-line"
                  label="인쇄"
                  onClick={() => window.print()}
                />
                {permission.level > 1 && (
                  <Button
                    className="print-button print-out ml-8"
                    color="gray-line"
                    label="견적서/발주서 매핑"
                    disabled={isEmpty(invoicePermission)}
                    onClick={() => {
                      setIsEtcInvoiceMapping(true);
                      setEtcInvoiceMappingData(list);
                    }}
                  />
                )}
              </div>
            </>

          )}
          <div className="trade-invoice-body">
            <div className="bill-form-header">
              <label className="tax-type-label">종류</label>
              <Radios
                field={{
                  key: "taxType",
                  defaultChecked: form.taxType,
                  onChange: handleOnChange,
                  options: {
                    list: TAX_TYPE_LIST,
                  },
                }}

              />
              <Button
                color="line"
                label="거래처 불러오기"
                size="sm"
                className="float-right"
                action={handleGetClient}
              />
            </div>
            <div className="bill-form-body">
              <div className="invoicer-bill">
                <BillForm
                  type="sup"
                  form={form}
                  onChange={handleOnChange}
                  errors={errors}
                  formType={'create'}
                />
              </div>
              <div className="invoicee-bill">
                <BillForm
                  type="byr"
                  form={form}
                  onChange={handleOnChange}
                  errors={errors}
                  formType={'create'}
                />
              </div>
              {isArray(fields) &&
                fields.map((_fields, index) => (
                  <table className="bill-additional-form" key={index}>
                    <tbody>
                      <tr>
                        {isArray(_fields) &&
                          _fields.map((field, idx) => (
                            <React.Fragment key={idx}>
                              <td className="additional-form-title">
                                {field.title}
                              </td>
                              <td className="additional-form-input">
                                {field.type === "datepicker" ? (
                                  <>
                                    <DatePicker
                                      field={field}
                                      defaultValue={form.writeDate}
                                      onChange={(date) => {
                                        setForm({ ...date });
                                        // const trDate = dateToFormat(date.writeDate[0], "D");
                                        // const newItemValues = itemValues.map(item => ({
                                        //   ...item,
                                        //   trDate
                                        // }))
                                        // setItemValues(newItemValues)
                                      }}
                                    />
                                    <span className="write-date-description">
                                      ※ 작성일자는 공급연월일을 의미함
                                    </span>
                                  </>
                                ) : (
                                  <DataComponent
                                    field={field}
                                    form={form}
                                    className={field.className}
                                    onChange={handleOnChange}
                                  />
                                )}
                              </td>
                            </React.Fragment>
                          ))}
                      </tr>
                    </tbody>
                  </table>
                ))}
              {/* recApeClCd */}
              <div className="recApeClCd">
                <Radios
                  field={{
                    key: "recApeClCd",
                    defaultChecked: form.recApeClCd,
                    options: {
                      list: [
                        { label: "영수", value: "01" },
                        { label: "청구", value: "02" },
                      ],
                    },
                    onChange: (e) => {
                      handleOnChange(e);
                    },
                  }}
                  className="box-style"
                />
              </div>
            </div>
            <div className="item-list-container">
              <div className="item-list-header">
                <p className="item-list-description">
                  ※ 품목의 월은 작성일자의 월이 표시되고 변경은 작성일자 수정시
                  자동 반영됨 (최대 16개 까지 가능)
                </p>
                <div className="header-button-wrap">
                  {itemHeaderButtons.map((button, idx) => (
                    <DataComponent
                      key={idx}
                      field={{
                        type: "button",
                        ...button,
                      }}
                    />
                  ))}
                </div>
              </div>
              <div className="item-list">
                <table>
                  <thead>
                    <tr>
                      {itemFields.map((item, idx) => (
                        <th key={idx}>
                          <span className={classnames("item-table-header", { required: item.required })}>{item.title}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {itemValues.map((item, idx) => (
                      <tr key={idx}>
                        {itemFields.map((_item, index) => (
                          <td key={index}>
                            {_item.key !== "sumCostCalc" && (
                              <DataComponent
                                className={_item.className}
                                field={_item}
                                onChange={(e) => handleOnChangeItemList(e, idx)}
                                form={itemValues[idx]}
                              />
                            )}
                            {_item.key === "prodName" && (
                              <DataComponent
                                field={{
                                  type: "button",
                                  label: "불러오기",
                                  size: "x-sm",
                                  color: "line",
                                  className: "float-right",
                                  action: () => {
                                    setItemSearchOpen(true);
                                    setItemIdx(idx);
                                  }
                                }}
                              />
                            )}
                            {_item.key === "sumCostCalc" && (
                              <Button
                                color="line"
                                size="x-sm"
                                label="계산"
                                action={() => {
                                  if (
                                    isEmpty(itemValues[idx].qty) ||
                                    isEmpty(itemValues[idx].unitCost)
                                  ) {
                                    if (isEmpty(itemValues[idx].unitCost)) {
                                      systemAlert("단가를 입력해주세요");
                                    }
                                    if (isEmpty(itemValues[idx].qty)) {
                                      systemAlert("수량을 입력해주세요");
                                    }
                                    return;
                                  }
                                  setCalculItemIdx(idx);
                                  setCalculatorValue(itemValues[idx]);
                                  setCalculatorOpen(true);
                                }}
                              />
                            )}
                          </td>
                        ))}
                        <td>
                          {itemValues.length > 1 && (
                            <IconButton
                              icon={DeleteIcon}
                              className="delete-btn"
                              onClick={() => handleOnRemoveItem(idx)}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {mode === "detail" && (
              <>
                {!isEmpty(mappedInvoiceData) && (
                  <div className="mapped-invoice-container">
                    <label className="related-header-title">
                      연관 거래명세서
                    </label>
                    <ControlTable
                      fields={mappedInvoiceFields}
                      list={mappedInvoiceData}
                      rowBtn={permission.level > 1 ? mappedInvoiceRowBtnConfig : {}} />
                  </div>
                )}

                {!isEmpty(mappedEtcInvoiceData) && (
                  <div className="mapped-invoice-container">
                    <label className="related-header-title">
                      연관 견적서/발주서
                    </label>
                    <ControlTable
                      fields={mappedEtcInvoiceFields}
                      list={mappedEtcInvoiceData}
                      rowBtn={permission.level > 1 ? mappedEtcInvoiceRowBtnConfig : {}}
                    />
                  </div>
                )}

                {!isEmpty(cashTransMappingData) && (
                  <div className="mapped-invoice-container">
                    <label className="related-header-title">
                      연관 기타거래 거래내역
                    </label>
                    <ControlTable
                      fields={bankTransFields}
                      list={cashTransMappingData}
                      rowBtn={permission.level > 1 ? mappedBankTransRowBtnConfig : {}} />
                  </div>
                )}
                {!isEmpty(bankTransMappingData) && (
                  <div className="mapped-invoice-container">
                    <label className="related-header-title">
                      연관 은행계좌 거래내역
                    </label>
                    <ControlTable
                      fields={bankTransFields}
                      list={bankTransMappingData}
                      rowBtn={permission.level > 1 ? mappedBankTransRowBtnConfig : {}} />
                  </div>
                )}
              </>
            )}

            <div className="submit-button-wrap float-right">
              <Button
                className="button"
                size="lg"
                label="취소"
                color="text"
                action={cancel}
              />
              {mode === "create" ? (
                <Button
                  className="button"
                  size="lg"
                  label="작성완료"
                  action={handleSubmit}
                />
              ) : (
                <Button
                  className="button"
                  size="lg"
                  label="수정"
                  action={handleSubmit}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
      {/* 거래처 불러오기 */}
      {clientSearchOpen && (
        <SelectClientInfo
          open={clientSearchOpen}
          setOpen={setClientSearchOpen}
          type={supByrType}
          form={form}
          setForm={setForm}
          searchType={"name"}
        />
      )}
      {/* 품목 조회 */}
      <SelectItemList
        open={itemSearchOpen}
        setOpen={setItemSearchOpen}
        form={itemValues}
        setForm={setItemValues}
        itemIdx={itemIdx}
      />
      {/* 공급가액 계산 */}
      <SupplyCostCalculator
        open={calculatorOpen}
        setOpen={setCalculatorOpen}
        data={calculatorValue}
        itemValues={itemValues}
        setItemValues={setItemValues}
        idx={calculItemIdx}
      />

      {/* 견적서or발주서 매핑하기 */}
      {isEtcInvoiceMapping && (
        <EtcInvoiceMapping
          open={isEtcInvoiceMapping}
          setOpen={setIsEtcInvoiceMapping}
          data={etcInvoiceMappingData}
          setData={setEtcInvoiceMappingData}
          listSubmit={() => setInvoice(list)}
          requesterType={"taxInvoice"}
        />
      )}

      {/* 거래처 등록하기 */}
      {accountOpen && !isEmpty(accountDefaultAddForm) && (
        <Client
          permission={accountPermission}
          open={accountOpen}
          setOpen={setAccountOpen}
          defaultAddForm={accountDefaultAddForm}
          addAccountSubmit={addAccountSubmit}
        />
      )}
    </>
  );
};

export default TaxInvoiceCreate;
